import { API_URL } from '../../../app-config/constants';
import MiniUser from '../../../types/MiniUser';
import ObjectiveClippy from '../../../types/ObjectiveClippy';
import { ChatHistoryItem, CopilotPromptType } from '../../react/features/AiCopilot/types';
import { get, post } from '../request';

const BASE_URL = `${API_URL}/copilot`;

export interface ManagerSummary {
    user: MiniUser;
    lastMeetingWithManager?: number;
    objectivesInCurrentCycle: ObjectiveClippy[];
    lastPraisedByManager?: number;
}

copilotPrompt.operation = 'COMMAND';
export function copilotPrompt(id: string, type: CopilotPromptType, input: string) {
    return post<ChatHistoryItem>(BASE_URL, { postData: { id, type, input } });
}

getReportSummary.operation = 'NO_OPERATION';
export function getReportSummary() {
    return get<ManagerSummary[]>(`${BASE_URL}/report-summary`);
}

getQuotaTokens.operation = 'NO_OPERATION';
export function getQuotaTokens(): Promise<number> {
    return get<number>(`${BASE_URL}/tokens`);
}
